import React, {useEffect, useState} from 'react'
import {useHistory} from 'react-router-dom'
import {useDispatch, useSelector, connect} from 'react-redux'
import {getJWTdata} from '../../Utils/tools'
import BannerConvenioPro from '../../Components/Banner/BannerConvenioPro'
import BannerMedicalFinderToday from '../../Components/Banner/BannerMedicalFinderToday'
import ButtonYapp from '../../Components/Buttons/ButtonYapp'
import {getProfessionalDiscountCode} from '../../Utils/api'

import IcConvenio from '../../assets/img/ic_yapp_approved.svg'
import icNuevosLanzamientosHomePro from '../../assets/img/ic_nuevos_lanzamientos_home_pro.svg'
import icInteracionesMedicamentosasHomePro from '../../assets/img/ic_interaciones_medicamentosas_home_pro.svg'
import icInformacionDeProgramasHomePro from '../../assets/img/ic_informacion_de_programas_home_pro.svg'
import icContactarLaboratorioHomePro from '../../assets/img/ic_contactar_laboratorio_home_pro.svg'
import icComprarMedicamentosHomePro from '../../assets/img/ic_comprar_medicamentos_home_pro.svg'
import IcBuscarFichasMedicamentosHomePro from '../../assets/img/lupa.svg'
import IcPreciosFarmaciasHomePro from '../../assets/img/farmacia.svg'
import IcConvenioYappHomePro from '../../assets/img/convenio-line.svg'
import IcInteraccionesMedicamentosaPro from '../../assets/img/interacciones_medicamentosa.svg'
import IcCoberturaCaecPro from '../../assets/img/cobertura-CAEC.svg'
import IcProgramaPacientePro from '../../assets/img/programa-pacientes.svg'

import {base_url, shareMessages, Menus} from '../../Utils/constants'
import {
  changeInitialLoading,
  setMenu,
  setTypeFormUrl,
  setModalTypeFormsState,
} from '../../redux/modules/app'
import {setUserProperties, shareWithColleagues} from '../../Utils/utils'
import {setProfessionalDiscountCode} from '../../redux/modules/user'
import {logEvent} from '../../Utils/utils'

function Explore(props) {
  const history = useHistory()
  const dispatch = useDispatch()
  // localStates
  const [modalState, setModalState] = useState(false)
  const [patientSavings, setPatientSavings] = useState(null)
  // globalStates
  const userInfo = useSelector((state) => state.user.userInfo)
  const config = useSelector((state) => state.app.config)
  const menu = useSelector((state) => state.app.menu)
  const identity = useSelector((state) => state.user.identity)
  // constants
  const {shareWebApp} = shareMessages
  const url = base_url

  useEffect(async () => {
    menu[0].isDisabled && dispatch(changeInitialLoading(true))
    let additionalMenu = []
    let newMenu = []
    let menus = [...Menus]

    try {
      let jwtData = getJWTdata()
      additionalMenu = await getProfessionalDiscountCode(
        jwtData?.user_id,
        identity,
      )
    } catch (ignore) {}

    if (additionalMenu.data?.length > 0 && additionalMenu.data[0]?.length > 0) {
      setUserProperties({'Benefit Code': true})
      dispatch(
        setProfessionalDiscountCode({
          code: additionalMenu.data[0][0].code,
          products: additionalMenu.data[1],
          categories: additionalMenu.data[2],
        }),
      )
      menus.push('agreement')
    } else {
      setUserProperties({'Benefit Code': false})
      menus.push('agreement-locked')
    }

    if (additionalMenu.data?.length > 3 && additionalMenu.data[3]?.length > 0) {
      setPatientSavings(additionalMenu.data[3][0].patient_savings)
    }

    for (const el of menu) {
      newMenu.push({
        ...el,
        isDisabled: !menus.includes(el.id),
        isHidden: !menus.includes(el.id),
      })
    }

    dispatch(setMenu(newMenu))
    dispatch(changeInitialLoading(false))
  }, [])

  const onShare = () => {
    let result = shareWithColleagues(url)
    if (result === false) {
      setModalState(true)
    }
  }

  const openTypeForm = (url, type) => {
    if (type === 'AAT' && url !== '') {
      dispatch(setTypeFormUrl(url))
      dispatch(setModalTypeFormsState(true))
    } else if (type === 'EDD' && url !== '') {
      dispatch(setTypeFormUrl(url))
      dispatch(setModalTypeFormsState(true))
    }
  }

  const goTo = (path) => {
    if (path !== '' && path) {
      if (path === '/search') {
        logEvent('Medication Buy Opened')
        window.open(config?.host_patient)
        try {
          setTimeout(function () {
            var userProperties = {
              'Web Name': process.env?.REACT_APP_CLIENT_NAME,
            }
            setUserProperties(userProperties)
          }, 3000)
        } catch (ignore) {}
      } else {
        history.push(path)
      }
    }
  }

  const goToPage = (url) => {
    switch (url) {
      case '/pro/new_agreement':
        logEvent('Yapp Benefit Opened', {
          Enabled: props?.professionalDiscountCode?.products?.length > 0,
        })
        break
      case '/pro/drug_interactions':
        logEvent('Drug Interaction Opened')
        break
      case '/pro/programs':
        logEvent('Program Information Opened')
        break
      case '/pro/new_drugs':
        logEvent('New Releases Opened')
        break
      case '/pro/laboratory':
        logEvent('Contact Laboratory Opened')
        break
      case '/pro/medication-sheet':
        logEvent('Medication Sheet Opened')
      default:
        break
    }
    goTo(url)
  }

  return (
    <div className="flex-grow-1 px-3">
      <div className="pt-3 content-responsive mx-auto">
        <div className="mb-2 d-none d-md-block d-xl-block d-lg-block">
          <BannerMedicalFinderToday goTo={(item) => goTo(item)} />
        </div>
        <div className="content-card-light">
          <h3 className="txt-2--regular-db m-0 mb-3 d-none d-md-block d-xl-block d-lg-block">
            Te apoyamos en la consulta{' '}
          </h3>
          <div className="d-none d-md-block d-xl-block d-lg-block banner-btn-convenio-more card-btn-home-large mb-2">
            <div className="d-flex flex-lg-row flex-column">
              <div className="mb-2 mr-md-2" style={{minWidth: '75%'}}>
                <BannerConvenioPro patientSavings={patientSavings} />
              </div>
              <div
                className="d-flex flex-row flex-lg-column banner-btn-convenio-more mb-1 c-pointer justify-content-around align-self-stretch"
                onClick={() => goToPage('/pro/new_agreement')}>
                <div className="d-flex flex-column">
                  <div className="d-flex flex-row flex-lg-column align-items-center">
                    <div className="order-2 order-lg-1 ml-2 mr-2">
                      <img src={IcConvenio} alt="Convenio Yapp" />
                    </div>
                    <div className="order-1 order-lg-2">
                      <h3 className="txt-4--bold-db m-1 text-lg-center">
                        Convenio Yapp
                      </h3>
                    </div>
                  </div>
                  <p className="txt-6--regular-db m-1 text-lg-center">
                    Descubre los descuentos en tratamientos para tus pacientes
                  </p>
                </div>
                <ButtonYapp className="m-0" title="Ver más" />
              </div>
            </div>
          </div>
          <div className="d-flex flex-column flex-md-row mb-md-2">
            <div
              id="gtm-webpro-goto-drug-interactions"
              className="card-btn-home mb-2 mb-md-0 mr-md-2 d-md-none d-xl-none d-lg-none"
              onClick={() => goToPage('/pro/medication-sheet')}>
              <div className="d-flex align-items-center">
                <img
                  className="icon-card-btn-home-small"
                  src={IcBuscarFichasMedicamentosHomePro}
                  alt="Información de medicamentos"
                />
                <div className="ml-3">
                  <h3 className="txt-4--bold-db m-0 mb-1">
                    Información de medicamentos
                  </h3>
                </div>
              </div>
              <i className="icon-chevron-right color-lilac"></i>
            </div>
            
            <div
              id="gtm-webpro-goto-pro-programs"
              className="card-btn-home mb-2 mb-md-0 mr-md-2 d-flex d-md-flex d-lg-none d-xl-none"
              onClick={() => goToPage('/pro/programs')}>
              <div className="d-flex align-items-center">
                <img
                  className="icon-card-btn-home-small"
                  src={IcProgramaPacientePro}
                  alt="programas de paciente"
                />
                <div className="ml-3">
                  <h3 className="txt-4--bold-db m-0 mb-1">
                    Programas de paciente
                  </h3>
                </div>
              </div>
              <i className="icon-chevron-right color-lilac"></i>
            </div>
            <div
              id="gtm-webpro-goto-drug-interactions"
              className="card-btn-home-large mb-2 mb-md-0 d-none d-xl-flex d-lg-flex"
              onClick={() => goToPage('/pro/drug_interactions')}>
              <div className="d-flex align-items-center">
                <img
                  className="icon-card-btn-home-large"
                  src={IcInteraccionesMedicamentosaPro}
                  alt="Interaciones Medicamentosa"
                />
                <div className="ml-3">
                  <h3 className="txt-4--bold-db m-0 mb-1">
                    Interacciones medicamentosas
                  </h3>
                </div>
              </div>
              <i className="icon-chevron-right color-lilac"></i>
            </div>
            {process.env.REACT_APP_PROFILE !== 'WIDGET' && (
              <div
                id="gtm-webpro-goto-search"
                className="card-btn-home-large mb-2 mb-md-0"
                onClick={() => goTo('/search')}>
                <div className="d-flex align-items-center">
                  <img
                    className="icon-card-btn-home-large"
                    src={icComprarMedicamentosHomePro}
                    alt="Interaciones Medicamentosa"
                  />
                  <div className="ml-3">
                    <h3 className="txt-4--bold-db m-0 mb-1">
                      Comprar medicamentos
                    </h3>
                    <p className="txt-6--regular-db m-0">
                      Los mejores precios, siempre
                    </p>
                  </div>
                </div>
                <i className="icon-chevron-right color-lilac"></i>
              </div>
            )}
          </div>
          <div className="d-flex flex-column flex-md-row flex-wrap">
            <div
              id="gtm-webpro-goto-pro-programs"
              className="card-btn-home mb-2 mb-md-0 mr-md-2 d-flex d-md-flex d-lg-none d-xl-none"
              onClick={() => goToPage('/pro/drug_interactions')}>
              <div className="d-flex align-items-center">
                <img
                  className="icon-card-btn-home-large"
                  src={IcInteraccionesMedicamentosaPro}
                  alt="Interaciones Medicamentosa"
                />
                <div className="ml-3">
                  <h3 className="txt-4--bold-db m-0 mb-1">
                    Interacciones medicamentosas
                  </h3>
                </div>
              </div>
              <i className="icon-chevron-right color-lilac"></i>
            </div>
            <div
              id="gtm-webpro-goto-drug-interactions"
              className="card-btn-home mb-2 mb-md-0 mr-md-2 d-md-none d-xl-none d-lg-none"
              onClick={() => goToPage('/pro/new_agreement')}>
              <div className="d-flex align-items-center">
                <img
                  className="icon-card-btn-home-large"
                  src={IcConvenioYappHomePro}
                  alt="Convenio Yapp"
                />
                <div className="ml-3">
                  <h3 className="txt-4--bold-db m-0 mb-1">
                    Cupones de descuento
                  </h3>
                </div>
              </div>
              <i className="icon-chevron-right color-lilac"></i>
            </div>
            <div
              id="gtm-webpro-goto-pro-programs"
              className="card-btn-home mb-2 mb-md-0 mr-md-2 d-none d-xl-flex d-lg-flex"
              onClick={() => goToPage('/pro/programs')}>
              <div className="d-flex align-items-center">
                <img
                  className="icon-card-btn-home"
                  src={icInformacionDeProgramasHomePro}
                  alt="Interaciones Medicamentosa"
                />
                <div className="ml-3">
                  <h3 className="txt-4--bold-db m-0 mb-1">
                    Información de programas
                  </h3>
                </div>
              </div>
              <i className="icon-chevron-right color-lilac"></i>
            </div>
            <div
              id="gtm-webpro-goto-pro-new-drugs"
              className="card-btn-home mb-2 mb-md-0 mr-md-2"
              onClick={() => goToPage('/pro/new_drugs')}>
              <div className="d-flex align-items-center">
                <img
                  className="icon-card-btn-home"
                  src={icNuevosLanzamientosHomePro}
                  alt="Interaciones Medicamentosa"
                />
                <div className="ml-3">
                  <h3 className="txt-4--bold-db m-0 mb-1">
                    Nuevos lanzamientos
                  </h3>
                </div>
              </div>
              <i className="icon-chevron-right color-lilac"></i>
            </div>
            <div
              id="gtm-webpro-goto-pro-laboratory"
              className="card-btn-home mb-2 mb-md-0"
              onClick={() => goToPage('/pro/laboratory')}>
              <div className="d-flex align-items-center">
                <img
                  className="icon-card-btn-home"
                  src={icContactarLaboratorioHomePro}
                  alt="Interaciones Medicamentosa"
                />
                <div className="ml-3">
                  <h3 className="txt-4--bold-db m-0 mb-1">
                    Contactar laboratorios
                  </h3>
                </div>
              </div>
              <i className="icon-chevron-right color-lilac"></i>
            </div>
            {/* <div
              id="gtm-webpro-goto-pro-programs"
              className="card-btn-home mb-2 mb-md-0 mr-md-2 d-lg-none d-xl-none d-md-none"
              onClick={() => goToPage(null)}>
              <div className="d-flex align-items-center">
                <img
                  className="icon-card-btn-home-large"
                  src={IcCoberturaCaecPro}
                  alt="Cobertura CAEC"
                />
                <div className="ml-3">
                  <h3 className="txt-4--bold-db m-0 mb-1">
                    Cobertura CAEC
                  </h3>
                  <p className="txt-6--regular-db m-0">
                    Busca medicamentos y sus reembolsos según previsión.
                  </p>
                </div>
              </div>
              <i className="icon-chevron-right color-lilac"></i>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    professionalDiscountCode: state.user.professional_discount_code,
  }
}

export default connect(mapStateToProps)(Explore)
